import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import { ImagePicker } from 'antd-mobile';
import * as styles from './styles/index.scss'
import intl from '@utils/intl'
export default class UploadImage extends ComponentExt<any, any>{
    constructor(props) {
        super(props)
        this.state = {
            files: []
        }
    }
    onChange = (files, operationType) => {
        if (operationType === 'add') {
            const file = files.length > 0 && files[files.length - 1]
            if (file && file.size / 1024 / 1024 > 5) {
                return this.$toast.fail(intl.formatMessage({ id: "suggest.uploadImg" }))
            }
        }
        this.setState({ files })
        this.props.getImageFiles(files)
    }
    render() {
        const { files } = this.state
        return <div className={styles.uploadImage}>
            <ImagePicker
                length="5"
                files={files}
                onChange={this.onChange}
                // onImageClick={(index, fs) => console.log(index, fs)}
                selectable={files.length < 5}
                accept="image/gif,image/jpeg,image/jpg,image/png"
            />
        </div>
    }
}